import { Modal, Button, Form } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { IInvoice } from '../../../model/invoice/Invoices';

interface IModalReject {
    showModal: boolean;
    setModalData: (args: any) => void;
    updateInvoice: (updateInvoice: IInvoice) => void;
    invoice: IInvoice;
}

export default function ModalInvoiceReject({ showModal, setModalData, updateInvoice, invoice }: IModalReject) {
    const nbChars = 1000;
    const [selectedReason, setSelectedReason] = useState(invoice.rejectReason);

    useEffect(() => {
        setSelectedReason(invoice?.rejectReason);
    }, [invoice]);

    const isRejectButtonDisabled = !selectedReason?.trim();

    return (
        <Modal show={showModal} onHide={() => setModalData((prev: any) => ({ ...prev, showModal: false }))} centered>
            <Modal.Header closeButton>
                <Modal.Title>Reject</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="rejectReason">
                        <Form.Label>Enter Rejection Reason</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={selectedReason}
                            onChange={e => setSelectedReason(e.target.value)}
                            placeholder="Enter reason for rejection"
                            maxLength={nbChars}
                        />
                        <Form.Text className="text-muted">
                            {selectedReason?.length ?? 0} / {nbChars} characters
                        </Form.Text>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="outline-primary"
                    onClick={() => setModalData((prev: any) => ({ ...prev, showModal: false }))}
                >
                    Close
                </Button>
                <Button
                    variant="danger"
                    onClick={() => updateInvoice({ ...invoice, rejectReason: selectedReason })}
                    disabled={isRejectButtonDisabled}
                >
                    Reject
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
